import React, {Component} from 'react';


class Home extends Component{

  render(){
    return(
      <div className="content-wrapper">
        {/* This is the home component */}
        {this.props.children}
      </div>
    )
  }
}

export default Home;
